import api from '../../api'
import { GET_EVENT_REQUEST, GET_EVENT_SUCCESS, GET_EVENT_FAILURE, SET_ACTIVE_EVENT, SET_ACTIVE_TEAM, SEND_ANSWER_SUCCESS } from '../mutation_types'

// Initial state
const state = {
    activeEvent: null,
    activateEventByPathname: true,

    // Recently played events and team
    recentEvents: localStorage.getItem('recentEvents') ? JSON.parse(localStorage.getItem('recentEvents')) : [],
    recentTeam: null,

    // Select event form state
    error: null,
    loading: false,
    loadingId: null
}

// Getters
const getters = {
    event: (state) => state.activeEvent
}

// Actions
const actions = {
    async selectEvent({commit}, id) {
        commit(GET_EVENT_REQUEST, id);

        try {
            const event = await api.getEvent(id);
            commit(GET_EVENT_SUCCESS);
            commit(SET_ACTIVE_EVENT, event);
        } catch (err) {
            commit(GET_EVENT_FAILURE, err);
        }
    }
}

// Mutations
const mutations = {
    [GET_EVENT_REQUEST] (state, id) {
        state.error = null
        state.loading = true
        state.loadingId = id
        state.activateEventByPathname = false
    },
    [GET_EVENT_SUCCESS] (state) {
        state.loading = false
    },
    [GET_EVENT_FAILURE] (state, error) {
        state.loading = false
        state.error = error
    },
    [SET_ACTIVE_EVENT] (state, event) {
        state.activeEvent = event

        // Add to top of recent events list
        state.recentEvents = state.recentEvents.filter(e => e._id !== event._id)

        state.recentEvents.unshift({
            _id: event._id,
            title: event.title,
            //logo: event.logoUrl || event.group.logoUrl
        })

        // Remember up to 5 recently played events
        state.recentEvents = state.recentEvents.slice(0, 5)
        localStorage.setItem('recentEvents', JSON.stringify(state.recentEvents))

        // Find recently used team
        if (localStorage.getItem(state.activeEvent._id + '.team')) {
            state.recentTeam = JSON.parse(localStorage.getItem(state.activeEvent._id + '.team'))
        } else {
            state.recentTeam = null
        }
    },
    [SET_ACTIVE_TEAM] (state, team) {
        localStorage.setItem(state.activeEvent._id + '.team', JSON.stringify({_id: team._id, name: team.name}))
    },
    EXIT_GAME(state) {
        state.activeEvent = null
    },
    [SEND_ANSWER_SUCCESS] (state, response) {
        const point = state.activeEvent.points.find(point => point.question._id === response.question._id)
        point.question.answers = response.question.answers
    },
}

// Export
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/events.js